var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"type":"date","label":_vm.label,"rules":_vm.rules,"min":_vm.min,"max":_vm.max,"disabled":_vm.disabled,"append-icon":"mdi-calendar","clearable":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }